import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
export var getKeyPressHandler = function getKeyPressHandler(callback) {
  var keys = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ["Enter", " "],
    stopPropagation = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
  return function (evt) {
    _includesInstanceProperty(keys).call(keys, evt.key) && (evt.preventDefault(), stopPropagation && evt.stopPropagation(), callback(evt));
  };
};